<div class="container" *ngIf="course" [ngClass]="{ 'is-edit-mode': isEditMode }">
<div class="title-row">
        <span class="ktitle-tiny">Attachments wow</span>
      </div>

<!-- Note: app-upload not working on creating a new course -->
 wow
<app-upload-file
  [fillSpace]="false"
  [noUploadDropzone]="false"
  [fileTypeInS3]="fileTypeInS3">
  <span overrideFooter class="kbody-small">PD, XLS, DOC, DOCx, JPG or PNG (max 10mb)</span>
</app-upload-file>

  <div class="buttons" *ngIf="!isEditMode">
    <app-button (click)="stepBackward()"
                [text]="'Previous Step'"
                [icon]="{materialIcon: 'arrow_back'}"
                [class]="'white'">
    </app-button>

    <div class="actions">
      <app-button [text]="'Cancel'"
                  [class]="'white'"
                  (click)="closeDialog()">
      </app-button>

      <app-button [icon]="{ materialIcon: 'arrow_forward' }"
                  [class]="'icon-right'"
                  [text]="'Next Step'"
                  (click)="updateCourse()">
      </app-button>
    </div>
  </div>
</div>